import { Device, DeviceId, DeviceType } from './device';
import { TILE_DEFAULT_WRITE_PRIORITY, TILE_TYPE_SIMPLE_ANALOG, Tile } from './tile';
import { TileIcon } from './tile-icon';
import { SimpleAnalogStructure } from './structure';
import { AUTO_CLEAR_ALL } from './alarm';
import { PROTOCOL_FORMULA } from './protocol';
import {
  TILE_APPEARANCE_DEFAULT_DECIMAL,
  TILE_APPEARANCE_DEFAULT_INCREMENT,
  TILE_APPEARANCE_DEFAULT_MULTIPLIER,
} from './appearance';

// Re-export all types from formula-config so existing imports from formula-device keep working
export {
  FormulaType,
  FormulaBindingSource,
  FormulaBinding,
  FormulaExpression,
  FormulaPoint,
  FormulaConfig,
} from './formula-config';

import { FormulaConfig } from './formula-config';

/** Builds the Device payload for formula device creation */
export function makeFormulaDevice(config: FormulaConfig): Device {
  return {
    Name: '',
    IP: '',
    Address: '',
    Hub: '',
    Owner: '',
    Type: DeviceType.Formula,
    Config: {
      Formula: config,
      Policies: {},
      AutoClear: AUTO_CLEAR_ALL,
    },
  };
}

/** Builds the initial Tile object for formula tile creation (DeviceID/PointID set later after formula device is created) */
export function makeInitialFormulaTile(name: string, icon: TileIcon = 'dot-circle'): Tile {
  const tile = Tile.createNew(TILE_TYPE_SIMPLE_ANALOG, name);
  tile.Appearance = {
    Icon: icon,
    Color: '',
    Config: {
      Decimal: TILE_APPEARANCE_DEFAULT_DECIMAL,
      Increment: TILE_APPEARANCE_DEFAULT_INCREMENT,
      Multiplier: TILE_APPEARANCE_DEFAULT_MULTIPLIER,
    },
    Template: '',
  };
  tile.Structure = {
    DeviceID: '',
    PointID: '',
    Protocol: PROTOCOL_FORMULA,
    Writable: false,
    AutoClear: AUTO_CLEAR_ALL,
    Priority: TILE_DEFAULT_WRITE_PRIORITY,
    Conditions: Tile.getDefaultAnalogConditions(),
    DisplayRawUnits: '',
    DisplayStates: [],
  } as SimpleAnalogStructure;
  return tile;
}

/** Builds a device-protocol Tile object (used when linking to a real device point instead of formula) */
export function makeDevicePointTile(name: string, deviceId: DeviceId, pointId: string, protocol: DeviceType, icon: TileIcon = 'dot-circle'): Tile {
  const tile = Tile.createNew(TILE_TYPE_SIMPLE_ANALOG, name);
  tile.Appearance = {
    Icon: icon,
    Color: '',
    Config: {
      Decimal: TILE_APPEARANCE_DEFAULT_DECIMAL,
      Increment: TILE_APPEARANCE_DEFAULT_INCREMENT,
      Multiplier: TILE_APPEARANCE_DEFAULT_MULTIPLIER,
    },
    Template: '',
  };
  tile.Structure = {
    DeviceID: deviceId,
    PointID: pointId,
    Protocol: protocol,
    Writable: false,
    AutoClear: AUTO_CLEAR_ALL,
    Priority: TILE_DEFAULT_WRITE_PRIORITY,
    Conditions: Tile.getDefaultAnalogConditions(),
    DisplayRawUnits: '',
    DisplayStates: [],
  } as SimpleAnalogStructure;
  return tile;
}
